var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#C92218"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 16.9187C26.809 12.7013 20.97 11.1636 15.5566 12.2839L18.307 15.0516C22.0941 14.8649 25.9359 16.2048 28.8172 19.1153L31 16.9187ZM26.6344 21.3119C25.2265 19.8951 23.5348 18.9725 21.734 18.5003L25.5866 22.3773L26.6344 21.3119ZM8.09141 10.3839L11.442 13.7337C9.83765 14.5244 8.33151 15.5788 7 16.9187L9.1719 19.1153C10.5252 17.7534 12.0859 16.743 13.7558 16.073L16.2005 18.5332C14.4325 18.9945 12.7517 19.9171 11.3656 21.3119V21.3229L13.5375 23.5085C15.0218 22.0148 16.9645 21.268 18.9072 21.246L26.6235 29L28.0096 27.6161L9.49932 9L8.09141 10.3839ZM15.7312 25.7051L19.0055 29L22.2797 25.7051C20.4789 23.8819 17.543 23.8819 15.7312 25.7051Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnection);
export default __webpack_public_path__ + "static/media/connection.581ccd510f6ffbe1e1cf8ee4226a3c54.svg";
export { ForwardRef as ReactComponent };